// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 810 ? "021e4126" : chunkId) + "." + {"139":"e0b8da9815ba2cf2","269":"f8e7b5be916b5008","739":"b743409b7344d12f","810":"161a23a098537977"}[chunkId] + ".js";
};